import { useDraggable } from '@dnd-kit/core'

import { Button } from '../ui/button'

// eslint-disable-next-line no-unused-vars
export const FormElementButton = ({ text, Icon, className = '' }) => (
  <Button
    variant="secondary"
    className={`w-full gap-3 transition-all duration-200 hover:shadow ${className}`}
  >
    <Icon className="h-[18px] w-[18px]" />
    <span>{text}</span>
  </Button>
)

function DraggableButton(props) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: props.text.toLowerCase().replace(' ', '-'),
    data: { element: props },
  })

  return (
    <li
      className={isDragging ? 'opacity-50' : 'opacity-100'}
      ref={setNodeRef}
      {...listeners}
      {...attributes}
    >
      <FormElementButton className="cursor-grab" {...props} />
    </li>
  )
}

export default DraggableButton
